import {gql} from '@apollo/client'

export const CREATE_SETTING = gql`
  mutation createSetting($settingData: setting_input!) {
    createSetting(settingData: $settingData) {
      setting {
        id
        name
        value
        loginReturn
      }
      success
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_SETTING = gql`
  mutation updateSetting($id: ID!, $settingData: setting_input!) {
    updateSetting(id: $id, settingData: $settingData) {
      setting {
        id
        name
        value
        loginReturn
      }
      success
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_SETTING = gql`
  mutation deleteSetting($id: ID!) {
    deleteSetting(id: $id) {
      success
      errors {
        field
        message
      }
    }
  }
`
